export const getParams = (paramName: any) => {
  const queryString = new URLSearchParams(window.location.search);
  const param = queryString.get(paramName);
  return param;
};
